<template>
  <div id="app" :style=" isShowTabbar?'padding-top:51px':'' "  >

     <!-- TabBar基础使用 -->
    <TabBar v-if="isShowTabbar" :tabs="tabs" @tab-change="onTabChange" :defaultActive="defaultActive"/>

    <!-- 非tabbar页显示back_title -->
    <div  v-if="!isShowTabbar && isShowMyTitle" class="fullwidth automargin height50 flex_row">
      <div @click="toback" class="uni-icon uni-icon-arrowleft inline flex1"></div>
      <div class="center flex1">{{$route.meta.title}}</div>
      <div class=" flex1"></div>
    </div>


    <img class="logo hidden" src="./assets/images/logo.png">
    <router-view v-wechat-title="$route.meta.title"/>

  </div>
</template>

<script>
import TabBar from '@/components/mytabbar.vue';
export default {
  name: 'App',
  components: {
    TabBar
	},
  data() {
    return {
      activeTab: 0,
      tabs: window.$config.tabbar,
      isShowTabbar:true, //是否显示Tabbar
      isShowMyTitle:false, //是否显示我的标题（back + title）
      isInWeixin: false, //是否在weixin
    }
  },

   computed: {

    // 使用 computed 获取 store 数据
    cartGoodsCount() {
      return window.$store.state.cartGoodsCount;
    },

  },

  watch: {
      // 监听完整路由对象
      $route: {
        handler(to, from) {
          console.group('路由变化追踪');
          if(from){
            console.log('从:', {
              路径: from.path,
              名称: from.name,
              参数: from.params,
              查询: from.query
            });
          }
          
          console.log('到:', {
            路径: to.path,
            名称: to.name,
            参数: to.params,
            查询: to.query,
            完整路径: to.fullPath,
            哈希: to.hash
          });
          console.groupEnd();
          
          // 记录导航历史
          // this.recordNavigation(from, to);
          
          // 统计页面访问
          // this.trackPageView(to);
          
          // 根据路由变化执行不同操作
          // this.handleRouteChange(to, from);

          this.showTabbar(to.path);
        },
        deep: true,  // 监听路由对象的深层变化
        immediate: true  // 组件创建时立即执行
      },



    // 2. 监听 computed 属性（推荐方式）
    cartGoodsCount: {
      handler(newCount, oldCount) {
        console.log('cartGoodsCount变化:', {
          新值: newCount,
          旧值: oldCount
        });
        this.showCartGoodsCount(newCount);
      },
      
    },
    

  },

  created(){
    console.log("tabbar");
    this.isInWeixin=window.$utils.isInWeixin(); //是否微信nei


    if(typeof this.$route.query.fromUid !='undefined'
        && !!this.$route.query.fromUid==true
        && this.$route.query.fromUid!='undefined'
        && this.$route.query.fromUid!='null'
        ){
        window.$utils.uniapi.setStorageSync("fromUid",this.$route.query.fromUid);
    }

  },

  methods: {

    toback(){
      this.$router.go(-1);
    },
    onTabChange(index, tab) {
      console.log('切换到:', tab.title)
    },

    // 判断是否显示tabbar
    showTabbar(currPath){
      if( currPath.indexOf("/")!==0 ){
        currPath="/"+currPath;
      }
      if(currPath=="/")currPath=window.$config.tabbar[0].path;
      var isShowTabbar=false; 
      for(var i=0;i<window.$config.tabbar.length;i++){
        if(currPath==window.$config.tabbar[i].path){ 
            isShowTabbar=true;
            this.defaultActive=i;
            break;
        }
      }
      this.isShowTabbar=isShowTabbar;
      
      //判断是否显示标题
      if(this.isShowTabbar || this.isInWeixin 
        || currPath.indexOf("/common_web")>=0 
        ){
        this.isShowMyTitle=false; //不显示标题
      }else{
        this.isShowMyTitle=true;
      }

      this.$forceUpdate();
    },


    //显示购物车商品数量
    showCartGoodsCount(c){
      for(let i=0;i<this.tabs.length;i++){
        if(this.tabs[i].title=='购物车'){
          this.tabs[i].badge=c;break;
        }
      }
    }

    

			
  }
}
</script>


<style scoped>
  #app{
    min-height: 100%;
    max-width: var(--h5-max-width); margin-left: auto;margin-right: auto;
  }


</style>



// WEBPACK FOOTER //
// src/App.vue